/* Calendar-day estimates: Paris order date, no network request or customer data. */
(() => {
  if (customElements.get('av-delivery-estimate')) return;
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.refresh = () => { this.updateDates(); this.updateAvailability(); };
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
      const form = this.closest('product-info')?.querySelector('product-form');
      if (form) {
        this.observer = new MutationObserver(() => this.updateAvailability());
        this.observer.observe(form, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled']});
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      this.observer?.disconnect();
    }
    updateAvailability() {
      const button = this.closest('product-info')?.querySelector('[name="add"]');
      if (button) this.hidden = button.disabled;
    }
    updateDates() {
      try {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(p => [p.type,p.value]));
        const base = Date.UTC(Number(parts.year), Number(parts.month)-1, Number(parts.day), 12);
        const min = Number(this.dataset.minDays), max = Math.max(min,Number(this.dataset.maxDays));
        if (!Number.isFinite(min) || !Number.isFinite(max) || min < 0 || max > 90) return;
        const dates = [new Date(base+min*86400000), new Date(base+max*86400000)];
        const locale = {fr:'fr-FR',en:'en-GB',de:'de-DE'}[this.dataset.locale] || 'fr-FR';
        const options = {timeZone:'UTC',day:'numeric',month:'long'};
        if (dates[0].getUTCFullYear() !== dates[1].getUTCFullYear()) options.year = 'numeric';
        ['start','end'].forEach((key,i) => {
          const target = this.querySelector(`[data-av-delivery-${key}]`);
          if (!target) return;
          const content = new Intl.DateTimeFormat(locale, options).format(dates[i]);
          if (target.textContent !== content) target.textContent = content;
          target.dateTime = dates[i].toISOString().slice(0,10);
        });
      } catch (_) { /* The initial server-rendered dates remain available. */ }
    }
  }
  customElements.define('av-delivery-estimate', DeliveryEstimate);
})();
